import React, {useMemo} from 'react';
import {Row} from 'react-bootstrap';
import {ObjectUtils} from "../../../Utils";
import {SurveyNavigationItem} from "./SurveyNavigationItem";
import {SurveyNavigationSeparator} from "./SurveyNavigationSeparator";
import {BOUNDARY_CODE} from "../../../Hooks/SubmissionBoundaryHooks";

const SurveyNavigationItemComponents = {
    [BOUNDARY_CODE]: SurveyNavigationSeparator,
};

export const SurveyNavigation = (props) => {
    const {
        Survey,
        CustomSections = [],
        CustomData,
        ConservationAction,
        Sections
    } = props;

    const sections = useMemo(() => {
        return ObjectUtils.Clone(Sections).reduce((merged, section) => {
            const existing = merged.find(item => item.name === section.name);

            if (existing) {
                // Merge the SurveyQuestions from the duplicate section name
                // into the existing section for purposes of the navigation bar
                existing.SurveyQuestions = [
                    ...existing.SurveyQuestions,
                    ...section.SurveyQuestions
                ];
            } else {
                merged.push(section);
            }

            return merged;
        }, []);
    }, [Sections]);

    return (
        <Row className="sb-survey-form-navigation-control">
            {sections.map((section, idx) => {
                const SurveyNavigationItemComponent =
                    SurveyNavigationItemComponents[section.code] ?? SurveyNavigationItem;
                return (
                    <SurveyNavigationItemComponent
                        key={section.surveySectionId}
                        section={section}
                        survey={Survey}
                        customSections={CustomSections}
                        customData={CustomData}
                        conservationAction={ConservationAction}
                    />
                );
            })}
        </Row>
    );
};
